export default __webpack_public_path__ + "static/ueber-uns-hover-5adb30a89c19ecf5c23279c3f0aafc99.png";